import { ref, push } from 'firebase/database';
import { database } from '../firebase';

export const submitContactForm = async (formData) => {
  try {
    const messagesRef = ref(database, 'contactMessages');
    const newMessageRef = await push(messagesRef, {
      ...formData,
      timestamp: new Date().toISOString(),
      status: 'new'
    });
    
    return { success: true, id: newMessageRef.key };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
}; 